__turbopack_context__.v({
  "actions": "_8rSeza_actions",
  "actionsContainer": "_8rSeza_actionsContainer",
  "active": "_8rSeza_active",
  "customAction": "_8rSeza_customAction",
  "footer": "_8rSeza_footer",
  "icon": "_8rSeza_icon",
  "listItem": "_8rSeza_listItem",
  "moreOptions": "_8rSeza_moreOptions",
  "moreOptionsList": "_8rSeza_moreOptionsList",
  "moreOptionsListItem": "_8rSeza_moreOptionsListItem",
});
